import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-member",
  "use": "icon-member-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-member\"><path d=\"M1023.653099 71.686692 656.984069 71.297836 293.587572 496.262574 293.587572 144.923694 293.587572 138.338718 293.587572 71.686692 0.346901 71.686692 0.346901 144.923694 73.731258 144.923694 73.731258 952.702164 293.587572 952.702164 293.587572 952.700117Z\" fill=\"\" p-id=\"17683\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol